import httpService from "./http.service";

class RedirectService {
    getRedirectsUrl = "/redirects";

    getRedirects = () => {
        return httpService.get(this.getRedirectsUrl);
    };
    createRedirect = (model) => {
        return httpService.post("/redirects", model);
    };
    deleteRedirect = (id) => {
        return httpService.delete("/redirects/" + id);
    };
}

const redirectService = new RedirectService();
export default redirectService;